module.exports = __webpack_public_path__ + "static/media/logo165.938f3283.png";